import { InputNumber } from 'primereact/inputnumber'

import i18n from '../../utils/i18n'

export const NumberFilterTemplate = (options: any) => {
  if (options == null) return null

  return (
    <InputNumber
      value={options.value}
      onChange={e => options.filterCallback(e.value, options.index)}
      min={0}
      locale={i18n.language}
      placeholder={i18n.t('common.placeholders.search')}
      showButtons
    />
  )
}
